import React from 'react';
import { MODAL_IDS } from '@src/containers/Session/constants';
import { FormCChoiceDynamic } from '@src/components/Form/connectors/dynamic';
import PopupCDefault from '../connectors/default';

const PopupCChoiceClaim = () => {
	const [isLoading, setIsLoading] = React.useState(true);

	const handleMount = React.useCallback(() => {
		setIsLoading(false);
	}, []);

	return (
		<PopupCDefault
			isCentred
			isPlated
			title={t('Заявка на подбор площадки')}
			modalId={MODAL_IDS.CHOICE}
			adaptive="claim"
			isLoading={isLoading}
		>
			<FormCChoiceDynamic onMount={handleMount} />
		</PopupCDefault>
	);
};

export default PopupCChoiceClaim;
